import { useEffect } from 'react';
import { PageContainer } from '@/shared/components/layout/PageContainer/PageContainer';
import { CampaignWizard } from '../../components/CampaignWizard/CampaignWizard';
import { useCampaignWizardStore } from '../../stores/campaign-wizard-store';
import styles from './CampaignWizardPage.module.scss';

export function CampaignWizardPage() {
  const reset = useCampaignWizardStore((s) => s.reset);

  useEffect(() => {
    // Reset on mount only when starting fresh; the sessionStorage-backed store
    // preserves an in-progress draft across refresh/return-to-tab.
    const { formData, completedSteps } = useCampaignWizardStore.getState();
    const hasInProgress = Object.keys(formData).length > 0 || completedSteps.length > 0;
    if (!hasInProgress) {
      reset();
    }
  }, [reset]);

  // No unmount reset — it would wipe the draft on navigate-away. The draft is
  // cleared on successful launch via store.reset().

  return (
    <PageContainer
      title="Create Campaign"
      breadcrumbs={[{ label: 'Campaigns', href: '/promote/campaigns' }, { label: 'New Campaign' }]}
    >
      <div className={styles.container}>
        <CampaignWizard />
      </div>
    </PageContainer>
  );
}
